/* ND: Swap product-card image on swatch hover/click instead of redirecting. */
(function () {
  'use strict';

  function swap(li) {
    if (!li || !li.dataset.variantImageUrl) return;
    var card = li.closest('.product-card');
    if (!card) return;
    var img = card.querySelector('.product-card__image--main img');
    if (!img) return;
    if (!img.dataset.ndOriginalSrc) {
      img.dataset.ndOriginalSrc = img.currentSrc || img.src || '';
      img.dataset.ndOriginalSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('src', li.dataset.variantImageUrl);
    if (li.dataset.variantImageSrcset) {
      img.setAttribute('srcset', li.dataset.variantImageSrcset);
    } else {
      img.removeAttribute('srcset');
    }
    /* Update card links so click on title/image goes to the chosen variant */
    if (li.dataset.variantUrl) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', li.dataset.variantUrl);
      });
    }
    /* Mark the active swatch */
    card.querySelectorAll('.nd-pcard-swatch-li').forEach(function (s) {
      s.classList.toggle('nd-pcard-swatch-li--active', s === li);
    });
  }

  /* Click: swap inline, do not navigate */
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest('.swatches--product-card a.swatch-color');
    if (!anchor) return;
    var li = anchor.closest('li.nd-pcard-swatch-li');
    if (!li || !li.dataset.variantImageUrl) return;
    e.preventDefault();
    swap(li);
  }, false);

  /* Hover: also swap (desktop nicety) */
  function bind() {
    document.querySelectorAll('.swatches--product-card li.nd-pcard-swatch-li').forEach(function (li) {
      if (li.dataset.ndBound) return;
      li.dataset.ndBound = '1';
      li.addEventListener('mouseenter', function () { swap(li); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  /* Re-bind after AJAX paging / filtering */
  new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });
})();
